import {createSlice} from "@reduxjs/toolkit";
import {json} from "../../lib/appfuse-react/core/json";
import Sort from "../../lib/appfuse-react/core/Sort";

const name = 'assessmentDecision';

const initialState = {
    data: [],
    selection: null,
    pageNumber: 0,
    pageSize: 10,
    criteria: {},
    sort: null,
    details: {}
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setData(state, action) {
            state.data = json.toJSON(action.payload);
        },
        setSelection(state, action) {
            state.selection = json.toJSON(action.payload);
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageSize(state, action) {
            state.pageSize = action.payload;
        },
        setCriteria(state, action) {
            state.criteria = json.toJSON(action.payload);
        },
        setSort(state, action) {
            state.sort = json.toJSON(action.payload);
        },
        setDetails(state, action) {
            state.details = json.toJSON(action.payload);
        }
    }
})

export const { setData, setSort, setCriteria, setSelection, setPageNumber, setPageSize, setDetails} = slice.actions;

export const selectData = state => json.fromJSON(state[name].data);
export const selectCriteria = state => state[name].criteria;
export const selectSort = state => json.fromJSON(state[name].sort, Sort);
export const selectSelection = state => json.fromJSON(state[name].selection);
export const selectPageNumber = state => state[name].pageNumber;
export const selectPageSize = state => state[name].pageSize;
export const selectDetails = state => json.fromJSON(state[name].details);
export const selectDetail = (key) => (state) => selectDetails(state)[key];

export const setDetail = (key, detail) => (dispatch, getState) => {
    const details = selectDetails(getState());
    details[key] = detail;
    dispatch(setDetails(details));
}

export const removeDetail = key => (dispatch, getState) => {
    const details = selectDetails(getState());
    delete details[key];
    dispatch(setDetails(details));
}

export const {reducer} = slice;
const assessmentDecisionReducer = reducer;
export default assessmentDecisionReducer;